// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const updateCurrentUserMutation = gql`
  mutation updateCurrentUser($userInfo: UpdateCurrentUserInput!) {
    updateCurrentUser(input: $userInfo) {
      code
      message
      currentUser {
        id
        auth0Id
        username
        firstName
        lastName
        fullName
        emails {
          emailAddress
          active
          isDeleted
          isPrimary
          isVerified
        }
        timezone
        modifiedDate
        socialAccounts {
          userId
          provider
          connection
          isSocial
        }
        avatarUrl
      }
    }
  }
`;
